import { Bell, Search, Calendar } from "lucide-react";
import { useDemo } from "@/demo/DemoContext";

export default function Topbar() {
  const { openBooking } = useDemo();
  return (
    <header
      data-testid="topbar"
      className="topbar-shadow sticky top-0 z-30 flex items-center justify-between px-8"
      style={{
        height: 64,
        background: "rgba(15, 25, 35, 0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: "1px solid var(--border-divider)",
      }}
    >
      <div className="flex items-center gap-3">
        <h1
          data-testid="app-title"
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 700,
            fontSize: 18,
            letterSpacing: "-0.02em",
            color: "var(--text-primary)",
          }}
        >
          MQL Nurture OS
        </h1>
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 10,
            padding: "3px 8px",
            borderRadius: 4,
            background: "rgba(0, 194, 168, 0.10)",
            color: "#00C2A8",
            border: "1px solid rgba(0, 194, 168, 0.25)",
            letterSpacing: "0.08em",
          }}
        >
          MEDICAL DEVICE · SALES ENABLEMENT
        </span>
      </div>

      <div className="flex items-center gap-3">
        <div
          className="hidden md:flex items-center gap-2 px-3 rounded-lg"
          style={{
            height: 36,
            background: "var(--bg-elevated)",
            border: "1px solid var(--border-divider)",
            width: 260,
          }}
        >
          <Search size={14} color="var(--text-muted)" />
          <input
            data-testid="topbar-search"
            placeholder="Search leads, sequences, agents…"
            style={{
              background: "transparent",
              border: "none",
              outline: "none",
              color: "var(--text-primary)",
              fontSize: 13,
              width: "100%",
              fontFamily: "Inter, sans-serif",
            }}
          />
          <span
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 10,
              color: "var(--text-muted)",
              padding: "2px 5px",
              borderRadius: 3,
              border: "1px solid var(--border-divider)",
            }}
          >
            ⌘K
          </span>
        </div>

        <button
          data-testid="topbar-audit-cta"
          onClick={openBooking}
          className="inline-flex items-center gap-1.5 rounded-lg"
          style={{
            padding: "8px 14px",
            background: "linear-gradient(135deg, #00C2A8 0%, #0EA5E9 100%)",
            color: "#0F1923",
            fontFamily: "Inter, sans-serif",
            fontSize: 12.5,
            fontWeight: 700,
            letterSpacing: "-0.005em",
            border: "none",
            cursor: "pointer",
            boxShadow: "0 0 18px rgba(0, 194, 168, 0.30)",
            transition: "transform 150ms ease, box-shadow 150ms ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = "0 4px 22px rgba(0, 194, 168, 0.50)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 0 18px rgba(0, 194, 168, 0.30)";
          }}
        >
          <Calendar size={13} strokeWidth={2.4} />
          Book Your Growth Audit
        </button>

        <button
          data-testid="topbar-notifications"
          className="flex items-center justify-center rounded-lg relative"
          style={{
            width: 36,
            height: 36,
            background: "var(--bg-elevated)",
            border: "1px solid var(--border-divider)",
            color: "var(--text-secondary)",
            cursor: "pointer",
          }}
        >
          <Bell size={15} />
          <span
            style={{
              position: "absolute",
              top: 8,
              right: 9,
              width: 6,
              height: 6,
              borderRadius: 999,
              background: "#00C2A8",
              boxShadow: "0 0 8px rgba(0, 194, 168, 0.7)",
            }}
          />
        </button>

        <div className="flex items-center gap-2.5 pl-3" style={{ borderLeft: "1px solid var(--border-divider)" }}>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: 999,
              background: "linear-gradient(135deg, #0EA5E9, #00C2A8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "Inter, sans-serif",
              fontWeight: 700,
              fontSize: 12,
              color: "#0F1923",
            }}
          >
            VP
          </div>
          <div className="hidden lg:block leading-tight">
            <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text-primary)" }}>Alex Rivera</div>
            <div style={{ fontSize: 11, color: "var(--text-muted)" }}>VP Sales · Demo</div>
          </div>
        </div>
      </div>
    </header>
  );
}
